import {Delete} from "@mui/icons-material";
import {Box, IconButton, LinearProgress, Typography} from "@mui/material";
import {defined} from "@variocube/app-ui";
import React from "react";
import {FilePreview} from "../../component/file-preview";
import {FileUpload} from "./create/types";

interface AttachmentItemProps {
	attachment: FileUpload;
	onDelete: () => void;
}

export function AttachmentItem({attachment, onDelete}: Readonly<AttachmentItemProps>) {
	return (
		<Box position="relative">
			<FilePreview file={attachment.file}/>
			<LinearProgress
				variant="determinate"
				color={getColor(attachment)}
				value={(attachment.progress ?? 0) * 100}
			/>
			<Typography variant="caption" textAlign="center">
				{attachment.file.name}
			</Typography>
			<IconButton
				color="error"
				onClick={onDelete}
				sx={{
					position: "absolute",
					top: 0,
					right: 0,
				}}
			>
				<Delete/>
			</IconButton>
		</Box>
	);
}

function getColor(attachment: FileUpload) {
	if (attachment.error || attachment.duplicates?.length || (defined(attachment.supported) && !attachment.supported)) {
		return "error";
	}
	if (attachment.checksum) {
		return "success";
	}
	return "secondary";
}
